import * as types from '../services/LoginActionType';

function authReducer(state = {}, action) {
    switch (action.type) {
        case types.LOGIN_REQUEST:
            return { ...state, isAuthLoading: true, isNoAccess: false };
        case types.LOGIN_SUCCESS:
            return { ...state, isAuthLoading: false, isNoAccess: false, userData: action.payload };
        case types.LOGIN_FAILURE:
            return { ...state, isAuthLoading: false, error: action.payload };

        case types.LOGOUT_REQUEST:
            return { ...state, isAuthLoading: true };
        case types.LOGOUT_SUCCESS:
            return { ...state, isAuthLoading: false, userData: null };
        case types.LOGOUT_FAILURE:
            return { ...state, isAuthLoading: false, error: action.payload };
        case types.NO_ACCESS:
            return {...state, isNoAccess: action.payload};
        case types.RESET_NO_ACCESS:
            return {...state, isNoAccess: false};

        default:
            return state;
    }
}
export default authReducer;